import axios from '../service/axios/axios'

export default {
  // 获取问诊单模板列表
  getInquirySheetLists(data) {
    return axios({
      method: 'post',
      url: 'platform/Inquirysheet/getInquirySheetLists',
      data,
    })
  },
  // 获取问诊单模板详情
  getInquirySheetInfo(data) {
    return axios({
      method: 'post',
      url: 'platform/Inquirysheet/getInquirySheetInfo',
      data,
    })
  },
  // 添加问诊单模板
  createInquirySheet(data) {
    return axios({
      method: 'post',
      url: 'platform/Inquirysheet/createInquirySheet',
      data,
    })
  },
  // 修改问诊单模板
  updateInquirySheet(data) {
    return axios({
      method: 'post',
      url: 'platform/Inquirysheet/updateInquirySheet',
      data,
    })
  },
  // 获取医生问诊单列表
  getDoctorInquiryList(data) {
    return axios({
      method: 'post',
      url: 'platform/Inquirysheet/getDoctorInquiryList',
      data,
    })
  },
}
